import { toRefs } from '@vueuse/shared';

import type {
  UseFooterNavigationReturn,
  UseFooterNavigationState,
  FetchFooterNavigation
} from '~/composables/useFooterNavigation/types';
import { useSdk } from '~/sdk';

/**
 * @description Composable managing customer order data
 * @returns {@link UseNavigationReturn}
 * @example
 * const { data, loading, fetchFooterNavigation } = useFooterNavigation();
 */
export const useFooterNavigation: UseFooterNavigationReturn = (id) => {
  const state = useState<UseFooterNavigationState>(`useFooterNavigation-${id}`, () => ({
    data: null,
    loading: false,
  }));

  /** Function for fetching customer order data
   * @example
   * fetchFooterNavigation();
   */
  const fetchFooterNavigation: FetchFooterNavigation = async (handle) => {
    state.value.loading = true;
    const { data, error } = await useAsyncData(() => {
      return useSdk().statamic.getFooterNavigation(handle);
    });
    useHandleError(error.value);
    state.value.data = data;
    state.value.loading = false;

    return data;
  };

  return {
    fetchFooterNavigation,
    ...toRefs(state.value),
  };
};
